module.exports = __webpack_public_path__ + "img/ph.169d8f3c.svg";